import React from "react";
import { Text, Button, Group } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import styles from "./RebookModal.module.css";

interface SuccessStepProps {
  /** Which entry point opened the modal — controls the secondary button. */
  source: "popover" | "transactionModal";
  onViewNewAppointment: () => void;
  onStayHere: () => void;
}

export default function SuccessStep({
  source,
  onViewNewAppointment,
  onStayHere,
}: SuccessStepProps) {
  return (
    <div className={styles.successContainer}>
      {/* Success Icon */}
      <div className={styles.successIcon}>
        <IconCheck size={40} className={styles.successIconInner} />
      </div>

      {/* Title */}
      <Text className={styles.successTitle}>Appointment Rebooked!</Text>

      {/* Message */}
      <Text className={styles.successMessage}>
        Your appointment has been successfully confirmed.
      </Text>

      {/* Buttons — centered. The transaction-modal entry shows a "Close" button
          that returns to the underlying transaction detail modal; the popover
          entry hides it (the modal's X closes to the calendar). */}
      <Group justify="center" gap="md">
        {source === "transactionModal" && (
          <Button variant="subtle" color="gray" onClick={onStayHere}>
            Close
          </Button>
        )}
        <Button color="var(--color-primary)" onClick={onViewNewAppointment}>
          View New Appointment
        </Button>
      </Group>
    </div>
  );
}
